document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('SerendipitousPop');
  if (!popup) return;

  const closeButtons = popup.querySelectorAll('[data-serendipitous-close]');
  const successMessage = popup.querySelector('[data-serendipitous-success]');
  const emailInput = popup.querySelector('.serendipitous-pop__input');

  const delay = Number(popup.dataset.delay || 6000);
  const expiryDays = Number(popup.dataset.expiryDays || 7);
  const storageKey = 'serendipitousPopDismissedUntil';

  const now = Date.now();
  const dismissedUntil = Number(localStorage.getItem(storageKey) || 0);

  function setDismissed(days) {
    const expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem(storageKey, String(expiresAt));
  }

  function openPopup() {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('serendipitous-pop-open');

    if (emailInput) {
      setTimeout(() => emailInput.focus(), 100);
    }
  }

  function closePopup(saveDismissal = true) {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('serendipitous-pop-open');

    if (saveDismissal) {
      setDismissed(expiryDays);
    }
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => closePopup(true));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
      closePopup(true);
    }
  });

  if (successMessage) {
    openPopup();
    setDismissed(30);

    setTimeout(() => {
      closePopup(false);
    }, 1800);

    return;
  }

  if (dismissedUntil > now) return;

  window.setTimeout(() => {
    openPopup();
  }, delay);
});